import React from 'react';
import { AlertTriangleIcon, CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { cn } from '../../utils/cn';
export type BadgeTone = 'neutral' | 'brand' | 'warn' | 'danger' | 'ok';
const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-canvas text-ink-muted border-line',
  brand: 'bg-brand-50 text-brand-800 border-brand-100',
  warn: 'bg-warn-50 text-warn-700 border-warn-100',
  danger: 'bg-danger-50 text-danger-700 border-danger-100',
  ok: 'bg-ok-50 text-ok-700 border-ok-100'
};

/**
 * Status must never be carried by colour alone. Outcome tones therefore
 * get a default shape as well as their label, so the badge still reads
 * correctly in greyscale or to a colour-blind user.
 */
const TONE_ICONS: Partial<Record<BadgeTone, React.ReactNode>> = {
  ok: <CheckCircle2Icon aria-hidden className="h-4 w-4 shrink-0" data-id="element-5174" data-mp="1x35xdjdp81l1" />,
  warn: <AlertTriangleIcon aria-hidden className="h-4 w-4 shrink-0" data-id="element-5175" data-mp="1x1bba1qoy3fd" />,
  danger: <XCircleIcon aria-hidden className="h-4 w-4 shrink-0" data-id="element-5176" data-mp="1s31gvtcsj6ut" />
};
interface BadgeProps {
  tone?: BadgeTone;
  icon?: React.ReactNode;
  /** Opt out of the default outcome shape for non-status labels. */
  plain?: boolean;
  children: React.ReactNode;
  className?: string;
}
export function Badge({
  tone = 'neutral',
  icon,
  plain,
  children,
  className
}: BadgeProps) {
  const shape = icon ?? (plain ? null : TONE_ICONS[tone]);
  return <span className={cn('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-caption font-medium', TONES[tone], className)} data-id="element-5177" data-mp="1ehqtqn0hvasd">
      {shape}
      {children}
    </span>;
}